import React, { Component } from 'react';
import history from '../../history';

import UserBadge from '../UserBadge';
import { TwoColumn } from '../inputs';
import Button from '../inputs/Button';
import Modal from '../Modal';
import { noBubble } from '../../utils/events';

import styles from './companyCard.module.scss';

export const getClassName = (isLongTerm, user) => {
  const base = isLongTerm
    ? styles.companyCardLongTerm
    : styles.companyCardLocation;
  const noAccess =
    user.accessLevel === 400 && user.projectIds && user.projectIds?.length > 0
      ? isLongTerm
        ? styles.companyCardLongTermNoAccess
        : styles.companyCardLocationNoAccess
      : '';
  return [base, noAccess].filter(Boolean).join(' ');
};

export default class CompanyCard extends Component {
  state = {
    modalOpen: false
  };

  handleDivClick = async (
    event,
    company,
    location,
    setActiveCompany,
    setActiveLocation,
    allLocations,
    setActiveGroups,
    setActiveProject,
    fromLoginScreen
  ) => {
    noBubble(event);
    setActiveCompany(company);
    setActiveLocation({
      ...location
    });
    setActiveProject();
    allLocations(company.allLocations);
    setActiveGroups(company.allLocations);
    history.push({
      pathname: '/app/dashboard',
      state: {
        showToasts: true,
        showNotificationModal: !this.props.user.notifications
      }
    });
  };

  openModal = e => {
    noBubble(e);
    this.props.setActiveCompany(this.props.company);
    this.props.setActiveLocation(this.props.location);
    this.setState({ modalOpen: true });
  };

  closeModal = e => {
    noBubble(e);
    this.setState({ modalOpen: false });
  };

  render() {
    const {
      company,
      location,
      setActiveCompany,
      setActiveLocation,
      allLocations,
      setActiveGroups,
      openProjectModal,
      openProjectDropdown,
      setActiveProject,
      handleProjectSelection,
      user,
      assignIncidentOwner,
      groupName
    } = this.props;

    const { modalOpen } = this.state;
    const visibleProjects = location?.projects?.some(
      project => !project.isHidden
    );

    return (
      <>
        <div
          className={`${styles.companyCardButton} ${getClassName(
            location.isSeparateEstablishment &&
              location.operationalForYearOrLonger,
            user
          )}`}
          onClick={e =>
            this.handleDivClick(
              e,
              company,
              location,
              setActiveCompany,
              setActiveLocation,
              allLocations,
              setActiveGroups,
              setActiveProject
            )
          }
        >
          <UserBadge
            showImage
            hoverName
            userId={location?.defaultIncidentOwner?.userId}
            size="medium"
            className={
              location.isSeparateEstablishment &&
              location.operationalForYearOrLonger
                ? styles.companyCardIncidentOwnerPictureWhite
                : styles.companyCardIncidentOwnerPictureBlue
            }
            onClick={e => {
              noBubble(e);
              assignIncidentOwner(
                location?.defaultIncidentOwner?.userId || undefined
              );
            }}
          />
          <div className={styles.companyCardAssignIncidentOwner}>
            {user.accessLevel > 400 ? 'Assign ' : ''}Incident Owner
          </div>
          <div className={styles.companyCardName}>{groupName}</div>
          {visibleProjects ? (
            <div
              className={
                location.isSeparateEstablishment &&
                location.operationalForYearOrLonger
                  ? `${styles.companyCardExistingProjects} ${styles.companyCardExistingProjectsWhite}`
                  : `${styles.companyCardExistingProjects} ${styles.companyCardExistingProjectsBlue}`
              }
              onClick={e => this.openModal(e)}
            >
              <div
                className={
                  location.isSeparateEstablishment &&
                  location.operationalForYearOrLonger
                    ? styles.companyCardExistingProjectsBlueWords
                    : styles.companyCardExistingProjectsWhiteWords
                }
              >
                Areas
              </div>
            </div>
          ) : (
            <div>
              {(user.accessLevel === 500 || user.accessLevel === 900) && (
                <div
                  className={styles.companyCardNewProject}
                  onMouseDown={noBubble(openProjectModal)}
                >
                  <div
                    className={
                      location.isSeparateEstablishment &&
                      location.operationalForYearOrLonger
                        ? styles.companyCardNewProjectWhiteWords
                        : styles.companyCardNewProjectBlueWords
                    }
                  >
                    Add First Area
                  </div>
                  <img
                    src={
                      location.isSeparateEstablishment &&
                      location.operationalForYearOrLonger
                        ? require('../../assets/images/newProject-white.png')
                        : require('../../assets/images/newProject-blue.png')
                    }
                    alt="boxWarning"
                    className={styles.companyCardNewProejctAddImage}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <Modal
          title={`${location.name}'s Areas`}
          titleClassName="blueHeader"
          isOpen={modalOpen}
          onRequestClose={e => this.closeModal(e)}
          hideButtons={true}
        >
          <div className="projectModal">
            <TwoColumn className={styles.companyCardProjectModal}>
              {location?.projects?.map?.((project, index) => {
                if (project.isHidden) return <></>;
                return (
                  <Button
                    key={index}
                    className="projectButton"
                    color="blueOutline"
                    text={project.name}
                    onClick={async () => {
                      await openProjectDropdown();
                      handleProjectSelection(project);
                    }}
                  />
                );
              })}
              {(user.accessLevel === 500 || user.accessLevel === 900) && (
                <Button
                  color="grey"
                  onClick={openProjectModal}
                  text="Add New Area"
                />
              )}
            </TwoColumn>
          </div>
        </Modal>
      </>
    );
  }
}
